import { Script } from "gatsby"
import readCookie from "@utils/read-cookie"
import readSubcookie from "@utils/read-subcookie"

export const addProductTracking = (pageData) => {
  const { productInterestTracking, navLink } = pageData
  return productInterestTracking ? (
    <MunchkinVisitWebPage url={navLink.url} params={`product=${productInterestTracking}`} />
  ) : null
}

export const MunchkinVisitWebPage = ({ url, params }) => {
  return (
    <Script name="Munchkin visitWebPage" id="munchkin-visitwebpage" strategy="idle">
      {`(function() {
          const readCookie = ${readCookie};
          const readSubcookie = ${readSubcookie};
          const optanonCookie = readCookie('OptanonConsent');
          const munchkinLoaded = window.Munchkin !== undefined
          const groups = optanonCookie && readSubcookie(optanonCookie, 'groups');
          if (munchkinLoaded && groups && groups.match(/funcs:([0-1])/)[1] !== '0') {
            Munchkin.munchkinFunction('visitWebPage', {
              'url': '${url}',
              'params': '${params}'
            })
          }
        })();`}
    </Script>
  )
}

const MunchkinScript = () => {
  // 👀 triggerMunchkinProductInterest will be removed since we are not relying on GTM for this functionality.
  return (
    <>
      <script name="Munchkin Tracking">{`function triggerMunchkinProductInterest() {}`}</script>
      <script name="Munchkin Tracking">{`
          if (window.Munchkin) {
            console.log('Munchkin should be ready')
          } else if (!window.Munchkin) {
            (function() {
              var didInit = false;
              function initMunchkin() {
                if(didInit === false) {
                  didInit = true;
                  Munchkin.init('025-XKO-469');
                }
              }
              var s = document.createElement('script');
              s.type = 'text/javascript';
              s.async = true;
              s.src = '//munchkin.marketo.net/munchkin.js';
              s.onreadystatechange = function() {
                if (this.readyState == 'complete' || this.readyState == 'loaded') {
                  initMunchkin();
                }
              };
              s.onload = initMunchkin;
              document.getElementsByTagName('head')[0].appendChild(s);
              })();
          }
      `}</script>
    </>
  )
}

export default MunchkinScript
